export class TierRasse {
    rasse_id: number;
    kuerzel: string;
    name: string;
    geburtsgewicht: number;
    tageszunahme: number;
    anzahl: number; // nur für Filter
}

export class TierRasseOutput {
    rasse: TierRasse;
    confirm: boolean = false;
}

export class TierRasseSonstige {
    tierrasse_id?: number;
    rasse: string;
    name: string;
    tierart_id: number;
}

export class Tierrasse2 {
    tierrasse_id: number;
    name: string;
    tierart_id: number;
    tierart: string;
}
